export default {
  helloWorld: "Hello World!",
  filters: "Filters",
  reset: "RESET",
  note: ["*Please Note:", "Must be 10 or more characters"],
  cookies: {
    info: [
      "We use cookies to improve user experience and site performance, and in some cases to personalize content and site advertising. For more information, see our Privacy Policy, or contact us at",
      "support@us.too.com.",
      "By continuing on this site, you agree to our use of cookies and our Privacy Policy. Too Corporation Americas does not sell your information.",
    ],
    "learn-more": "Learn more",
    "got-it": "GOT IT!",
  },
  "need-help": "NEED HELP WITH SOMETHING?",
  "contact-us": "CONTACT  US",
  "see-all-info": "SEE ALL INFORMATION",
  title: "Copic Markers | Official US Site and Store | Create with Copic",
  loading: "Loading",
  show: "SHOW",
  hide: "HIDE",
  base: {
    "load-more": "LOAD MORE",
    "add-to-cart": "add to cart",
    "next-page": "NEXT",
    "backward-page": "PREV",
    catalog: "Our Catalog",
    copied: "copied",
    "copic-shop": "Copic Shop",
    redeem: "redeem",
    "already-redeem": "already redeem",
    drawer: "Cart Drawer",
    signin: "Sign In",
    register: "Register",
    "help-email": "support@us.too.com",
    home: "Home",
    create: "Create",
    account: "Account",
    "buy-now": "Buy now",
    educational: "Educational",
    news: "News",
    "our-markers": "Our Markers",
    "about-us": "About Us",
    "drawing-gallery": "DRAWING GALLERY",
    "store-locator": "Store Locator",
    "view-more": "View more",
    "read-more": "Read more",
    "havent-account": "Don't have an account?",
    "have-account": "Already have an account?",
    footer: {
      copyrights: [
        " Too Corporation Americas. All Rights Reserved.",
        "Terms of Service",
        "Privacy Policy",
      ],
      "follow-us": "FOLLOW US",
    },
  },
  "seo-news": {
    title: "News | Copic",
    description:
      "Stay updated on art and illustration news with Copic. Explore techniques, inspiration, events, tips, reviews, and join our creative community. Unleash Copic markers for next-level creations",
  },
  select: {
    option: "SELECT OPTION",
  },
  profile: {
    greet: "Hi, ",
    actions: ["View Orders", "Copic Club", "Account Info", "Sign Out"],
  },
  bannerBottom: {
    "our-markers": {
      title: "MARKER BREAKDOWN & COMPARISON CHART",
      content: "Get the most out of your markers!",
      button: "LEARN MORE",
    },
    "about-us-banner": {
      title: "GET TO KNOW OUR MARKERS",
      content: "which marker is the best one for you?",
      button: "LEARN MORE",
    },
    "general-banner": {
      title: "SUBSCRIBE FOR OFFERS, UPDATES, & MORE!",
      content:
        "Join our email list and be the first to know about new products, receive special offers, giveaways, exclusive deals and more!",
      button: "SUBSCRIBE",
      placeHolder: "Enter your email address",
    },
  },
  auth: {
    "errors-message": {
      required: "Required",
      "invalid-email-address": "• The email address may be wrong",
      "invalid-password": "• The password may be wrong",
      "email-blank": "• Email can't be blank",
      "password-blank": "• Password can't be blank",
      "new-password-blank": "• New password can't be blank",
      "repeat-password-blank": "• Repeat password can't be blank",
      "name-blank": "• Name can't be blank",
      "password-length": "• Password is too short (Minimum is 8)",
      "password-not-match": "• Password does not match",
    },
    "register-email": {
      title: "WELCOME TO TOO!",
      description:
        "Congratulations, your account has been successfully created.",
      button: " Visit our store",
    },
    "check-your-email": {
      title: "CHECK YOUR MAIL",
      message: [
        "We have sent a password recover instructions to your email",
        "Did not receive the email?",
        "Check spam or",
      ],
      button: "try another email address",
    },
    "password-restored": {
      title: "PASSWORD RESTORED",
      message: [
        "Your password has been successfully restored, you can now",
        "Sign In",
        "with your new password.",
      ],
    },
    "recover-password": "Recover password",
    "sign-in": "Sign In",
    "remember-me": "Remember me",
    "forgot-password": "Forgot Password?",
    intructions:
      "Please enter your email address and your password to sign in.",
    "instructions-reset": [
      "Enter your account email to receive instructions on how to reset your password.",
      "If that email address is in our system, you will receive an email with instructions about how to reset your password in a few minutes.",
    ],
    "intructions-reset-page-form":
      "To change your current password, please enter the new password on both fields.",
    new: "New",
    repeat: "Repeat",
    reset: "Reset",
    send: "SEND",
    or: "or",
    name: "Name",
    email: "Email Address",
    password: "Password",
    "offers-opt-in":
      "Please send me online promotions and special offer emails.",
    disclaimer:
      "When you create or use an online account, we collect information that allows us to identify you such as your name and contact information. We will also collect certain commercial information necessary to complete any purchase. For store pickup orders, we will also collect certain commercial information.",
    "already-have-account": "ALREADY HAVE AN ACCOUNT?",
  },
  "order-detail": {
    "back-to-my-orders": "Back to My Orders",
    overview: "OVERVIEW",
    "receipt-for-order-number": "Receipt for order number",
    "print-order": "PRINT ORDER",
    "order-details": "Order Details",
    "order-number": "Order Number",
    "order-date": "Order Date",
    "order-status": "Order Status",
    completed: "Completed",
    "number-of-items": "Number of Items",
    total: "Total",
    subtotal: "Subtotal",
    shipping: "Shipping",
    discount: "Discount",
    handling: "Handling",
    taxes: "Taxes",
    "add-all-to-cart": "ADD ALL TO CART",
    "shipment-info": "Shipment Info",
    shipped: "Shipped",
    "tracking-number": "Tracking Number",
    "shipping-method": "Shipping Method",
    "buy-again": "BUY AGAIN!",
    "view-all-past-purchases": "(VIEW ALL PAST PURCHASES)",
  },
  "progress-bar": {
    level: "level",
    "current-level": "current level",
    "next-level": "next level",
    next: "Next",
    content: ["you have", "you need", "points"],
  },
  "side-bar": {
    "account-information": "Account Information",
    "copic-club": "Copic Club",
    "my-orders": "My Orders",
    "buy-again": "Buy Again",
    "my-wish-list": "My Wish List",
    "gift-cards-and-vouchers": "Gift Cards and Vouchers",
  },
  "my-orders": {
    "my-account": "MY ACCOUNT",
    "my-orders": "My Orders",
    "order-view": "0 orders placed",
    "not-any-orders": "You have not placed any orders.",
    text: ["You have placed", "orders. Check your", "progress."],
    "order-no": "ORDER NO.",
    date: "DATE",
    items: "ITEMS",
    total: "TOTAL",
    status: "STATUS",
    "easy-re-order": "EASY RE-ORDER",
    "add-all-to-cart": "ADD ALL TO CART",
  },
  "buy-again": {
    "buy-again": "Buy Again",
    text: [
      "View the full list of items you’ve ever purchased. It’s an easy way to re-order your favorite items! Looking for your order history grouped by order? View",
      "My Orders",
      ".",
    ],
    product: "PRODUCT",
    price: "PRICE",
    quantity: "QUANTITY",
    subtotal: "SUBTOTAL",
    "easy-re-order": "EASY RE-ORDER",
  },
  search: {
    header: "Search Results",
    blog: {
      title: "BLOGS",
      "no-result": "No results for",
    },
    input: {
      placeholder: "What are you looking for?",
    },
    "submit-button": "SEARCH",
    "x-results": "results",
  },
  home: {
    title: "copic-with-us",
    "copic-with-us": {
      title: "COPICWITHUS",
      text: [
        "Did you follow our tutorials blogs? use the hashtag ",
        "#copicwithus ",
        "so we can see your amazing work!",
      ],
    },
    "know-our-markers": {
      title: "GET TO KNOW OUR MARKERS",
      description: "which marker is the best one for you?",
      compare: "COMPARE",
      learn: "LEARN MORE",
      markers: {
        classic: {
          name: "CLASSIC MARKERS",
          year: "SINCE 1987",
        },
        sketch: {
          name: "SKETCH MARKERS",
          year: "SINCE 1993",
        },
        ciao: {
          name: "CIAO MARKERS",
          year: "SINCE 1998",
        },
        acrea: {
          name: "ACREA MARKERS",
          year: "SINCE 2024",
        },
      },
    },
    "artboard-banner-1": {
      title: "NEW HATSUNE MIKU LIMITED SET",
      text: "Hatsune Miku makes her Copic debut! In collaboration with Hatsune Miku, color your favorite Vocaloid with 5 specially selected Copic Ciao markers and an exclusive Multiliner!",
    },
    "artboard-banner-2": {
      title: "IC COMIC ILLUSTRATION KIT",
      text: "The IC Comic Illustration Kit includes tools for drawing monochrome comic illustrations, as well as an introductory book on how to draw 'Manga Lesson', which is a key point in drawing comic illustrations.",
    },
    "view-all": "VIEW ALL",
    "shop-our-sets": {
      title: "SHOP OUR SETS",
      "title-2": "EXPLORE OUR SHOP",
      button: "GO TO OUR SHOP",
    },
    news: {
      message:
        "Be the first to know about the latest Copic information: new products, events and more!",
    },
    "latest-educational": {
      title: "LATEST EDUCATIONAL BLOGS!",
      message:
        "Where you will find a lot of helpful content that will serve you as an asset and make the most out of your markers.",
      blog: {
        title: "How To Color Leaves Part 1",
        description:
          "In our previous blog, we explained how to draw and outline 12 \r different leaves. Today, we will be showing how to color 6 of those leaves using your Copic markers: Oak, Elm, Maple, Walnut, Ginkgo, and Chestnut. Without further ado, let’s get started with the first step below, which is figuring out your color palettes! The first step before coloring your subject is to figure out the correct palette! Test your marker colors on a separate sheet of marker paper before finalizing each group.",
      },
    },
  },
  "product-detail": {
    "unavailable-product-message": {
      title: "ARE YOU INTERESTED IN THIS PRODUCT?",
      body: [
        "Sorry, but we don't have it available in the shop right now. But! You can use our",
        "Store Locator",
        "and find that product on a store near you.",
      ],
    },
  },
  "product-card": {
    markup: {
      "out-of-stock": "out of stock",
    },
  },
  catalog: {
    title: "Catalog",
    seo: {
      description:
        "Explore the versatility and quality of Copic markers. Browse our catalog of markers for artists and designers.",
    },
    filter: {
      hint: "You can add the products to your Wishlist and get notify when available for sell!",
    },
    sugestion: {
      title: "see something you like?",
      text: "You can use our Store Locator and find that product on a store near you.",
      button: "find a store",
    },
    showcase: {
      title: ["explore more", "from our catalog"],
    },
  },
  ourMarkers: {
    "get-to-know-our-markers": "Get To Know Our Markers",
    "markers-sets": "Markers Sets",
    "alcohol-based-dye-ink": {
      title: "ALCOHOL-BASED DYE INK",
      subTitle: "SMOOTHER, VIVID COLORS",
      textPlane:
        "A fast-drying, transparent alcohol ink will not harm the surface or fibers in the paper allowing it to remain smooth. The ink used is low-odor, and non-toxic.",
    },
    "copic-color-system": {
      title: "COPIC COLOR SYSTEM",
      subTitle: "ENDLESS POSSIBILITIES",
      textPlane:
        "All 358 colors have been organized so you can select colors intuitively. With a variety of color families, blending groups, and intensity, there are endless possibilities to express your color.",
    },
    "replaceable-nibs-refilllable-ink": {
      title: "REPLACEABLE NIBS & REFILLABLE INK",
      subTitle: "LONGER MARKER LIFE",
      textPlane:
        "All types of nibs can be replace with standard Spare Nibs. Exclusive Optional Nibs can be used with Classic or Sketch markers. All 358 colors are available as ink refills for all Copic marker types.",
    },
    "copic-skecth-sets": {
      title: "COPIC SKECTH SETS",
      subTitle: "MOST POPULAR AMONG ALL COPIC MARKERS",
      textPlane:
        "All COPIC Sketch products are centered around a distinct passion for quality. The 3, 6, 12, 24, 36, and 72-piece sets are the perfect addition to any kit. Endless color combinations and a selection of nibs bring to life rich and imaginative compositions. Any creation is made possible with a COPIC Sketch Marker in hand.",
    },
    "copic-classic-sets": {
      title: "COPIC CLASSIC SETS",
      subTitle: "FIRST STYLE CREATED OF THE COPIC MARKER FAMILY",
      textPlane:
        "The COPIC Classic comes in a variety of basic color selections from the 12-Piece Set to a rich 72-Piece Set. COPIC Classic gives artists a chance to discover compositions using fun lines and pigment arrangements. From a few simplistic sketches to a collection of complex creations.",
    },
    "copic-ciao-sets": {
      title: "COPIC CIAO SETS",
      subTitle: "MOST ECONOMICAL COPIC MARKER",
      textPlane:
        "The 180-color collection is perfect for any dynamic illustration or personalized crafting. The COPIC Ciao Marker offers a range of pigments curated in sets specific for creative tasks: each offering a unique saturation combination, from the 6-piece brights to the rich 72-piece basic.",
    },
  },
  "copic-club": {
    headers: ["JOIN THE COPIC CLUB", "WELCOME TO THE COPIC CLUB"],
    text: "As a member you'll earn points & exclusive rewards every time you shop.",
    buttons: {
      "join-now": "JOIN NOW",
      "log-in": "LOG IN",
    },
    "earn-to-win": "EARN POINT EVERY TIME YOU SHOP AND LEVEL UP!",
    rewards: {
      "product-reward":
        "You have won a new <div>%{reward}</div> This will come in with the next order!",
      "coupon-reward":
        "You've won a <div>%{reward}</div> coupon Remember this coupon expires and is only one use, Copy and pasted to the checkout.",
      current: "Current Status",
      level: "LEVEL %{level}",
      "points-needed": "YOU NEED %{points} POINTS",
      earn: "EARN MORE POINTS",
      "owner-points": "YOU HAVE %{points} POINTS",
    },
    content: {
      "how-it-works": {
        header: "HOW IT WORKS",
        titles: {
          "sign-up": "Sign up",
          "earn-points": "EARN POINTS",
          "get-rewards": "GET REWARDS",
        },
        text: [
          "Create an account",
          "Earn points every time you shop.",
          "Get amazing rewards as you level up!",
        ],
        id: {
          "01": "01",
          "02": "02",
          "03": "03",
        },
      },
      "level-up-and-get-rewarded": {
        header: "LEVEL UP AND GET REWARDED",
        text: "With Copic Club, you get rewarded for getting involved. That’s why whenever you shop, you earn points that unlock new levels and rewards. The more you get involved, the more you level up and get rewarded.",
      },
      "reward-points": {
        header: "REWARD POINTS",
        text: [
          "Every time you place an order through your account you will receive reward points.",
          "So for example, if you register for a Copic account and purchase a $100 marker set, you will earn 200 points which will up your level and you can win rewards!",
          "You can check your balance by visiting your account information on the site.",
          "So what are you waiting for? ",
          "and earn amazing rewards!",
          "For every $1 spent = you receive 2 points.",
          "Level up by accumulating points and earn rewards.",
        ],
      },
    },
  },
  address: {
    default: "Default address",
    modal: {
      title: "ADD A NEW ADDRESS",
      description:
        "Please enter an address you would like to save and deliver your items to.",
      country: "Country",
      state: "State/Province",
      city: "City",
      name: "Full name",
      phone: "Phone Number",
      address: "Address",
      zip: "Zip Code",
      default: "Make this my default address.",
      button: "add address",
    },
  },
  shop: {
    title: "Shop",
    seo: {
      description:
        "Shop the best selection of Copic markers. Choose from a wide range sets to fit your needs. Refillable ink and unmatched quality. Shop now.",
    },
    "go-to-shop": "Go to the Shop",
    menu: {
      "sketch-markers": "Sketch Markers",
      "classic-markers": "Classic Markers",
      "ciao-markers": "Ciao Markers",
      "see-all": "See All",
      "see-all-products": "ACREA MARKERS",
      "line-art-gallery": "Line Art Gallery",
    },
    product: {
      "sold-out": "sold out",
      price: "Price",
      title: "Product",
      quantity: "Quantity",
      subtotal: "subtotal",
      item: "item",
      "see-available": "See available sets in the shop",
      "shipping-policy": "Shipping & Returns Policy",
      description: "description",
      "acmi-approved": {
        header: "acmi approved",
        content: {
          title: "Acmi AP Seal",
          body: "The seal identifies art materials that these products are safe and certified in a toxicological evaluation by a medical expert to contain no materials in sufficient quantities to be toxic or injurious to humans, including children, or to cause acute or chronic health problems.",
          "learn-more": "learn more",
        },
      },
      hurry: ["Hurry! Only", "left in stock"],
      "max-items": ["Max. ", "item per order."],
    },
    checkoutAction: {
      "your-order": "Your Order",
      subtotal: "Subtotal",
      "order-total": "Order total",
      "estimated-shipping": "Estimated Shipping",
      "calculate-at-checkout": "Calculate at checkout",
      taxes: "Taxes",
    },
    help: {
      "need-Help?": "Need Help?",
      email: "support@us.too.com",
    },
    cart: {
      "order-summary": "Order summary",
      "save-items-for-later": ["or", "to save items in your cart for later"],
      "proceed-to-checkout": "PROCEED TO CHECKOUT",
      "go-to-checkout": "GO TO CHECKOUT",
      "view-cart": "VIEW CART",
      "ship-and-returns": [
        "Please check our",
        "Shipping & Returns Policy ",
        "before",
        "placing your order.",
      ],
      "shopping-cart": "Shopping Cart",
      "add-to-cart": "Add to cart",
      "coming-soon": "Coming Soon",
      "view-product": "View Product",
      "pre-order": "Preorder now",
      "taxes-and-shipping":
        "Shipping, taxes, and discount codes calculated at checkout",
      "empty-cart": "Your Cart is Empty",
      "checkout-message": [
        "You can cancel the order within 48 hours after and no modifications to orders after placed!",
        "Please check everything before placing the order.",
        "By placing your order, you agree to Too Corporation Americas's",
        "privacy policy ",
        "and conditions of use.",
      ],
      "visit-our-shop": "Visit our shop",
      items: "Items in your cart",
      "only-ship": "We ship only to the US at the moment.",
      text: ["or", "to save items in your cart for later."],
      "empty-cart-button": "EMPTY CART",
      "empty-cart-design": {
        "cart-currently-empty": "Your cart is currently empty",
        "have-an-account": "Have an account?",
        "to-see-items-later":
          "to see the items in your cart or saved for later.",
        "shop-as-guest": "SHOP AS A GUEST",
      },
    },
    filter: {
      "no-match": {
        0: "Sorry, no matches found :(",
        1: "Please try another search",
        button: "Clear all filters",
      },
      "clear-all": "Clear All",
      "our-shop": "Go Our Shop!",
      "filter-by": "Filter by",
      "show-results": "SHOW RESULTS",
      hint: "Click here to see our full catalog!",
      "price-range": {
        title: "Price Range",
        "under-25": "Under $25",
        "25-50": "$25 To $50",
        "50-100": "$50 To $100",
        "100-200": "$100 To $200",
        "above-200": "$200 & Above",
      },
      "product-categories": {
        title: "Product Categories",
        markers: "Markers",
        sets: "Sets",
        pens: "Pens",
        "copic-ink-refills": "Copic Ink & Refills",
        paper: "Paper",
        accessories: "Accessories",
      },
      markers: {
        title: "Markers & Pens",
        sketch: "Sketch",
        classic: "Classic",
        ciao: "Ciao",
        acrea: "acrea",
        muiltiliners: "Muiltiliners"
      },
      pieces: {
        title: "No. Of Pieces",
        "3pc": "3 Pieces",
        "6pc": "6 Pieces",
        "12pc": "12 Pieces",
        "24pc": "24 Pieces",
        "36pc": "36 Pieces",
        "72pc": "72 Pieces",
      },
      color: {
        title: "Color Family",
        bv: "Blue Violet (BV)",
        v: "Violet (V)",
        rv: "Red Violet (RV)",
        r: "Red (R)",
        yr: "Yellow Red (YR)",
        y: "Yellow (Y)",
        yg: "Yellow Green (YG)",
        g: "Green (G)",
        bg: "Blue Green (BG)",
        b: "Blue (B)",
        e: "Earth (E)",
        c: "Cool Gray (C)",
        n: "Neutral Gray (N)",
        t: "Toner Gray (T)",
        w: "Warm Gray (W)",
        fluorescent: "Fluorescent Colors",
        black: "Black",
        colorless: "Colorless",
      },
      availability: {
        title: "Availability",
        "pre-order": "Preorder",
        "in-stock-only": "In Stock Only",
        "in-stock": "In Stock!",
        "limited-edition": "Limited Edition",
      },
    },
  },
  "about-us": {
    seo: {
      title: "About us | Copic",
      description:
        "COPIC Marker is high quality marker for industrial design, architecture design, fashion design, graphics, illustrations, craft, model design. COPIC Marker is sustainable for long use you can replace nibs and refill inks",
    },
    title: "About Us",
    description:
      "Copic markers were developed by Too Corporation back in 1987. They were originally created for fine art and design, then the Japanese comic industry (Manga & Anime) began using the products. These versatile markers are popular for product design, architecture, fashion design, comic illustration, automotive design and crafts. Now Copic markers are distributed in more than 50 countries around the world and receiving international acclaim.",
    "about-too": {
      title: "ABOUT TOO",
      content: [
        "Too Corporation Americas is a subsidiary of Too Corporation of Japan.",
        "Too group companies manufacture and distribute innovative art and creative design products.",
        "Too group is committed to making the highest quality markers in order to meet the demand of customers globally.",
      ],
    },
    history: {
      title: "HISTORY OF COPIC",
      content: [
        "In 1969, Izumiya introduces “Speedry Markers” in Japan. The first marker pen specifically developed for designers. There were 150 colors available. Izumiya changes its name to the Too Corporation in 1992.",
        "In 1987, the first Copic Markers (Classic) are introduced in Japan with 71 colors. The markers were developed in response to designer’s need for photocopy-safe markers. By 1997, Copic Classic markers are available in 214 colors.",
        "In 1993, Copic Sketch markers were introduced with 144 colors. Over the next two decades, more colors are added to reach a total of 358 by 2012.",
        "In 1998, Copic Ciao markers are introduced with 72 colors to provide a more affordable option for beginners and aspiring creative professionals. 180 colors are now available.",
        "In 2015, to celebrate Miffy’s 60th anniversary, a special limited set of Ciao markers is released for “The 60 Years With Miffy” exhibition.",
      ],
    },
    "product-releases": "PRODUCT RELEASES",
    "authorized-distributors": "AUTHORIZED DISTRIBUTORS",
    "official-retailers": "OFFICIAL RETAILERS",
    button: "GO TO STORE LOCATOR",
  },
  account: {
    activate: {
      title: "Activate Account",
      description:
        "To activate your account, please enter the new password on both fields.",
      button: {
        title: "Activate Account",
      },
    },
    title: "My account",
    // going to change to real data later
    level: {
      name: "Hi ",
      description:
        "As a member you'll earn points & exclusive rewards every time you shop.",
    },
    information: {
      title: "ACCOUNT INFORMATION",
      description:
        "Feel free to edit any of your details below so your account is totally up to date.",
      subtitle: "My information",
    },
    "change-password": {
      title: "CHANGE PASSWORD",
      content:
        "Feel free to update your password so your account stays secure.",
      "some-thing-wrong": "• Looks like something went wrong try again later",
      "current-password-wrong": "• Current password maybe wrong",
      "current-password-blank": "• Current password can't be blank",
      "new-password-short": "• New password is too short (Minimum is 8)",
      "new-password-blank": "• New password can't be blank",
    },
    "billing-address": {
      title: "BILLING ADDRESS",
      description: "Set your Billing Address",
      "input-label": {
        country: "Country/Region",
        state: "State/Province",
        city: "City",
        zipcode: "Zip Code",
        address: "Address",
      },
    },
    buttons: {
      save: "Save Changes",
      password: "Change password",
      address: "Add new address",
    },
    "address-book": {
      title: "ADDRESS BOOK",
      description:
        "Every time you buy all your shipping address will be save here.",
      subtitle: "Shipping Address ",
    },
    "mail-preferences": {
      title: "MAILING PREFERENCES",
      description:
        "We occasionally sends out catalogs and promotions via mail. If you do not want us to send you mail, uncheck this box.",
      label: "Please send me catalogs and flyers.",
    },
  },
  "not-found": {
    title: "404",
    description:
      "Oops! We can't seem to find the page you are looking for. Try going back or go to the homepage.",
    button: "go to home",
  },
  "not-found-blog": {
    title: "404",
    description:
      "Oops! We can't seem to find the page you are looking for. Try going back or go to the news.",
    button: "go to news",
  },
  "store-locator": {
    seo: {
      title: "Store locator | Copic",
      description:
        'After inputting the City, State, or Zip Code, map will adjust when you click on the "See on Map" button on the store of your choosing. To locate by State, please input the two letter State code (i.e. TX, CA, NY).',
    },
    title: "Find A Store Near You",
    button: "FIND STORE",
    "my-location": "Use My Current Location",
    placeholders: {
      zip: "Zip Code",
      address: "State, City or Address",
    },
    btnNearStore: "See nearby stores",
    findeMoreStores: "Find More Stores",
    section: {
      title: "TRENDING PRODUCTS",
      button: "GO TO OUR SHOP",
    },
    alert: "Geolocation is not supported by this browser.",
    "see-on-map": "VIEW ON MAP",
    "visit-site": "Visit site",
    "not-store-available": "0 store(s) locations available",
    "not-found": "WE COULDN'T FIND ANY STORE NEARBY YOUR LOCATION",
    "search-again": "SEARCH AGAIN",
    "near-message": ["Near to your location", "within"],
    "find-retailer": "Check where you can buy our products online:",
    visit: "visit site",
  },
  "order-status": {
    ATTEMPTED_DELIVERY: "Attempted delivery",
    CANCELED: "Canceled",
    CONFIRMED: "Confirmed",
    DELIVERED: "Delivered",
    FAILURE: "Failure",
    FULFILLED: "Fulfilled",
    IN_PROGRESS: "In Progress",
    IN_TRANSIT: "In transit",
    LABEL_PRINTED: "Label printed",
    LABEL_PURCHASED: "Label purchased",
    LABEL_VOIDED: "Label voided",
    MARKED_AS_FULFILLED: "Marked as fulfilled",
    NOT_DELIVERED: "Not delivered",
    ON_HOLD: "On Hold",
    OPEN: "Open",
    OUT_FOR_DELIVERY: "Out for delivery",
    PARTIALLY_FULFILLED: "Partially Fulfilled",
    PENDING_FULFILLMENT: "Pending",
    PICKED_UP: "Displayed as Picked up",
    READY_FOR_PICKUP: "Ready for pickup",
    RESTOCKED: "Restocked",
    SCHEDULED: "Scheduled",
    SUBMITTED: "Submitted",
    UNFULFILLED: "Unfulfilled",
  },
  educational: {
    banner: {
      text: "A gallery of line drawings available to download for coloring.",
      title: "LINE ART GALLERY",
    },
    tags: "Tags",
    title: "Educational",
    markers: "GET THE MOST OUT OF YOUR MARKER",
    filter:
      "You can filter our content using the tags or sort the best way for you.",
    description:
      "Welcome to our educational page! Here you will find a lot of helpful content that will serve you as an asset and make the most out of our products.",
    seo: {
      description:
        "Discover a wealth of educational resources and insights at COPIC's official blog. Explore a wide range of topics, including tutorials, tips, and techniques to master the art of coloring. Enhance your artistic skills, broaden your creative horizons, and find inspiration through our informative articles and engaging content. Join the vibrant community of artists and educators, and unleash your potential with COPIC markers. Start your educational journey today!",
    },
    "read-more": "Read More Articles",
  },
  "sidebar-menu": {
    "account-info": "Account Information",
    "view-orders": "View Orders",
  },
  "shipping-and-Returns": {
    seo: {
      title: "Shipping and Returns Policy | Copic",
      description:
        "Too Corporation Americas Return & Refund Policy Thank you for shopping with us! If you have any questions or concerns about a product purchased through our store, please contact us at support@us.too.com, and our team will help you. We ship within the United States from our warehouse located in Californi",
    },
  },
  "privacy-policy": {
    seo: {
      title: "Privacy Policy | Copic",
      description:
        "TCA Privacy Policy Too Corporation Americas (“TCA,” “we,” or “us”) collects various personal information from you from your use of the services provided by TCA. Please read this privacy policy carefully to get a clear understanding of how TCA collects, uses, protects, processes, and otherwise handles your personal info",
    },
  },
  "terms-of-service": {
    seo: {
      title: "Terms of Service | Copic",
      description:
        "TCA Terms of Service Too Corporation Americas (“TCA,” “we,” or “us”) provides this website for use to the general public upon the following terms. If you do not accept these terms, do not use this website. 1. Use License The materials contained in this website are protected by applicable copyright and trademark law. Pe",
    },
  },
  "marker-creakdown-&-comparison-chart": {
    title: "Marker Breakdown & Comparison Chart",
    cards: {
      titles: ["SKETCH MARKERS", "CLASSIC MARKERS", "CIAO MARKERS", "ACREA MARKERS"],
      description: [
        "Copic Sketch has earned its popularity by hosting the widest range of colors, and featuring Medium Broad and flexible Super Brush nib combination.",
        "The Classic marker is the first style created and has continually been the most customizable Copic with the option of 9 different nibs.",
        "The Ciao marker is the most economical Copic, providing the same great quality and experience as Sketch, at a more attractive price.",
        "Copic acrea is a water and pigment-based paint marker. This fully opaque ink can be used on many materials and works on dark surfaces."
      ],
    },
    "comparision-chart": {
      titles: [
        "Available Colors",
        "Ink Base",
        "Ink Capacity",
        "Approx. # of Refill with Various Ink (25ml)",
        "Approx. Ink Amount per Refill",
        "Approx. Ink Amount for Copic Original (Empty Marker)",
        "Nib Included",
        "Nib Replacements Available",
        "Barrel Shape",
        "Airbrush System Compatible",
        "The average number of B4 size (257mm x 364mm) sheet in cases of painting whole area evenly with Broad Nib",
        "Special child-safe cap with small air holes",
      ],
      sketch: [
        "358",
        "Alcohol",
        "3.6ml",
        "~13",
        "~1.8ml / ~0.06oz",
        "~3ml",
        "Medium Broad & Super Brush",
        [
          "Original:",
          " Medium Broad, Super Brush",
          "Alternative:",
          " - Brush side: Sketch Fine",
        ],
        "image",
        "YES",
        "3.7",
        "NO",
      ],
      classic: [
        "214",
        "Alcohol",
        "5ml",
        "~13",
        "~2.5ml / ~0.085oz",
        "~4ml",
        "Standard Broad & Standard Fine",
        [
          "Original:",
          " Standard Broad, Standard Fine",
          "Alternative:",
          "- Bullet side: Semi Broad,",
          "Calligraphy 3 mm, Super Fine",
          "- Chisel side: Soft Broad,",
          "Calligraphy 5 mm, Round, Brush",
        ],
        "image",
        "YES",
        "5",
        "NO",
      ],
      ciao: [
        "180",
        "Alcohol",
        "2.85ml",
        "~17",
        "~1.7ml / ~0.05oz",
        "—",
        "Medium Broad & Super Brush",
        ["Original: Medium Broad, Super", "Brush"],
        "image",
        "NO",
        "2.7",
        "YES",
      ],
      acrea: [
        "24",
        "Water-based Pigment/ Paint",
        "3ml",
        "-",
        "-",
        "—",
        "-",
        "-",
        "image",
        "NO",
        "-",
        "NO",
      ],
    },
    seo: {
      title: "Marker Breakdown & Comparison Chart | copic",
      description:
        "Learn about the best Copic marker tool for you between the Copic Sketch, Copic Classic, and Copic Ciao product lines. All are acid free, alcohol-based pigment with refillable ink, an ACMI-certified, environmentally-friendly",
    },
    "see-this-maker": "SEE MARKER",
  },
  "drawing-gallery": {
    seo: {
      title: "Line Art Gallery | Copic",
      description:
        "Free Copic line art to practice using Copic products like Copic Sketch, Copic Classic, Copic Ciao, and Copic Ink",
    },
    title: "Line Art Gallery",
    image: "image",
    subtitle: "LINE DRAWINGS FOR COLORING",
    articles: "Learn More With Our Educational Articles",
    description: [
      "LINE DRAWING: FREE DOWNLOAD",
      "* Click/tap to enlarge image",
      "* For personal use only.",
      "* Commercial use, secondary use and redistribution of all line drawings is not permitted.",
    ],
    about: {
      title: "ABOUT DOWNLOADING DATA",
      description: [
        "Please download or use line drawing data posted on this page at your own risk. We do not assume any liability or responsibility for any loss or damage arising from download or use of the data. ",
        "The ownership of copyright in each line drawing belongs to the artist of the work. You are free to post the image of line drawing you colored on social media, but copyright ownership of the work (i.e. line drawing) will not be transferred therefore you are not allowed to claim you have copyright ownership.",
        "For personal use only. Commercial use, secondary use and redistribution of all line drawings is not permitted.",
      ],
    },
    available: "AVAILABLE DRAWINGS",
    download: "Download",
  },
  faq: {
    title: "FAQ",
    "sub-title": "FREQUENTLY ASKED QUESTIONS",
    description:
      "For any queries, check the most common questions below, If they do not clarify your doubts, please",
    "contact-us": "contact us.",
    seo: {
      title: "Faq | copic",
      description:
        "FAQ or Frequently Asked Questions on COPIC as the original, premium alcohol-based refillable marker in Sketch, Ciao, Classic, and Ink product lines.",
    },
  },
  "thanks-contact-us": {
    title: "THANKS FOR CONTACTING US!",
    seo: {
      title: "",
      description: "",
    },
    description:
      "We appreciate you contacting us. One of our colleagues will be in touch with you shortly! Have a great day!",
    buttons: {
      back: "SEND ANOTHER MESSAGE",
      return: "RETURN TO HOME",
    },
  },
  "copic-set-update-notice": {
    seo: {
      description:
        "Effective August 1st, 2020, all Copic marker sets shipped to the North America region will bear the holographic stickers identifying the product for US and Canada sale only. This will affect the following sets: Classic/Original: 12 PC Sets (Basic, Cool Gray, Neutral Gray, Toner Gray, and Warm Gray) 36 PC Basic Set 72 P",
    },
  },
  umap: {
    seo: {
      description:
        "COPIC Unilateral Minimum Advertise Price (UMAP) Policy This Policy applies to all authorized partners, distributors, wholesalers and retailers who resell COPIC products to customers located in North America (collectively “Authorized Resellers”) This Policy is designed to support COPIC as a premium brand, and to maintai",
    },
  },

  guarantee: {
    seo: {
      description:
        "Copic® Marker Consumer Guarantee 90-Day Satisfaction Guarantee Too Corporation Americas (TCA) is the exclusive distributor of Copic® markers in North America. At TCA, we stand behind our products and quality controls. Therefore, we offer you our Consumer Guarantee: If for any reason you are not satisfied with a Copic p",
    },
  },
  "Contact-us": {
    title: "CONTACT US",
    description: [
      "We would be pleased to answer your questions about our Copic Products.",
      " Click here for our FAQ. ",
      "If you can't find the answer you're looking for, we are ready to help!",
    ],
    seo: {
      title: "Contact Us | copic",
      description: "",
    },
    form: {
      fields: {
        require: "Required Fields",
        name: "Name",
        email: "E-mail Address",
        state: "Choose your State / Province",
        stateNotFound: "State not found.",
        country: "Choose your country",
        department: "Department",
        title: "Title / Topic",
        description:
          "Please give us a description of the problem or question you have:",
      },
      departments: ["SALES", "CUSTOMER SUPPORT"],
      buttons: {
        submit: "SEND",
      },
      "errors-message": {
        "name-blank": "Name can't be blank.",
        "email-blank": "E-mail can't be blank.",
        "email-invalid": "The email adress may be wrong.",
        "state-blank": "State / Province can't be blank.",
        "country-blank": "Country can't be blank.",
        "department-blank": "Department cant't be blank.",
        "title-blank": "Title / Topic can't be blank.",
        "description-blank": "Description can't be blank.",
      },
    },
  },
  "info-page": {
    "need-help": "NEED HELP WITH SOMETHING?",
    content:
      "We gather all the information you need on one page. If you can't find what you need fell free to",
    "contact-us": "contact us",
    button: "CHECK IT OUT",
  },
  ResubscriptionToast: {
    title: "YOUR REQUEST HAS BEEN SENT",
    description:
      "We accepted your request. Support will activate your Newsletter Subscription again in no time",
  },
  "count-down-info": {
    text: "Copic Crate Mystery Boxes - Coming Soon!",
    description: "Limited Quantities Available.",
    days: "days",
    hours: "hours",
    minutes: "minutes",
    seconds: "seconds",
  },
  suscribe: {
    popup: {
      title: "CHECK YOUR EMAIL",
      description: "Confirm your email to finish subscribing to our Newsletter",
    },
    title: "Don't Miss Out",
    form: {
      placeholder: "Email address",
      button: "SUBMIT",
    },
    description: "Be the First to Hear of Our Best Deals",
  },
  general: {
    retailers: "Retailers",
    available: "Available Now",
    comingSoon: "Coming Nov 1",
  }
};
